import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import styles from './styles';

function EquipmentOrderGroupItem({ classes, equipment, dragging, drawInsertionCaret, ...rest }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: equipment?._id,
    data: { type: 'equipment', color: equipment?.color },
    disabled: false,
  });
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <Grid
      item
      xs={12} lg={3} xl="auto"
      style={{ position: 'relative' }}
      className={drawInsertionCaret ? classes[`caret${drawInsertionCaret}`] : null}
    >
      <Card
        className={classnames(classes.card, (isDragging || dragging) ? classes.itemDragging : null)}
        style={style}
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        {...rest}
      >
        {equipment.color && (
          <div className={classes.colorLine} style={{ backgroundColor: equipment.color }} />
        )}
        <Box className={classes.boxBody}>
          <DragIndicatorIcon />
          <Grid container className={classes.paddingBox}>
            <Grid item xs={12} className={classes.paddingBottom}>
              <div className={classnames(classes.inlineFlex, classes.flexHeader)}>
                <Typography variant="h6" color="textPrimary" className={classes.fixedWidth}>
                  {equipment.name}
                </Typography>
              </div>
            </Grid>
            {equipment.number && (
              <Grid item xs={12}>
                <Typography variant="body1" color="textSecondary">
                  #{equipment.number}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Card>
    </Grid>
  );
}

export default withStyles(styles)(EquipmentOrderGroupItem);